import api from '../../plugins/api';

const getOgpoLink = (orderId) => {
  return api.post('/api/shop/getOgpoLink', { orderId });
};

export default getOgpoLink;
